export const UPDATE_QUESTIONS_SEARCH_RESULT = 'UPDATE_QUESTIONS_SEARCH_RESULT'
